"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConcordiumWalletQrModal = void 0;
var qrcode_modal_1 = __importDefault(require("@walletconnect/qrcode-modal"));
var TypedEventEmitter_1 = __importDefault(require("./TypedEventEmitter"));
var ConcordiumWalletQrModal = /** @class */ (function () {
    function ConcordiumWalletQrModal(opts) {
        var _this = this;
        this.pubSub = TypedEventEmitter_1.default;
        this.pubSub.on('close', function () {
            _this.close();
            opts.onClose();
        });
    }
    ConcordiumWalletQrModal.prototype.close = function () {
        qrcode_modal_1.default.close();
    };
    ConcordiumWalletQrModal.prototype.open = function (msg) {
        var _this = this;
        qrcode_modal_1.default.close();
        qrcode_modal_1.default.open(msg.connect_string, function () { return _this.pubSub.emit('close'); });
    };
    return ConcordiumWalletQrModal;
}());
exports.ConcordiumWalletQrModal = ConcordiumWalletQrModal;
